import { render, staticRenderFns } from "./DocumentTypeConfiguration.vue?vue&type=template&id=2e6d8dca&scoped=true"
import script from "./DocumentTypeConfiguration.vue?vue&type=script&lang=js"
export * from "./DocumentTypeConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6d8dca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
